import FixedAspectRatioImg from "@/ts/base/Components/FixedAspectRatioImg";

class DefaultHero {
	protected el: HTMLElement|null = null;
 	protected fixedAspectRatioImg: FixedAspectRatioImg|null = null;

	constructor(el: HTMLElement|null) {
		this.el = el;

		if (this.el instanceof HTMLElement) {
			if (this.el.classList.contains("maintain-aspect-ratio")) {
				const img = this.el.querySelector(".maintain-aspect-ratio img");
				if (img instanceof HTMLImageElement) {
					this.fixedAspectRatioImg = new FixedAspectRatioImg(img);
				}

				window.addEventListener("resize", this.onWindowResize.bind(this));

				this.updateSize();
			}
		}
	}

	updateSize() {
		if (this.el instanceof HTMLElement && this.fixedAspectRatioImg instanceof HTMLElement) {
			this.el.style.minHeight = this.fixedAspectRatioImg.getRealHeight().toString().concat("px");
		}
	}

	onWindowResize() {
		this.updateSize();
	}
}

export default DefaultHero;
